import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, Observable } from 'rxjs';

@Injectable()
export abstract class ValidatorService {
    public notify = new Subject<any>();
    public notifyObservable$ = this.notify.asObservable();
    public abstract getFormGroup(): FormGroup;
    public abstract notifyOther(data: any): boolean;
}
